// DO NOT EDIT -- generated from fs/services/search-settings/classificationrules.proto

import * as protoauditstore from '../../gcloud/dstore/protoauditstore';

export namespace ClassificationRules {

  export const SetClassificationRuleEndpoint = "/grpc/search_settings.ClassificationRules/SetClassificationRule";
  /** Create/update existing classification rule */
  export function SetClassificationRule(sender: (req: SetClassificationRuleRequest, endpoint: string) => Promise<SetClassificationRuleResponse>, req: SetClassificationRuleRequest): { promise: () => Promise<SetClassificationRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetClassificationRuleEndpoint),
      endpoint: SetClassificationRuleEndpoint
    };
  }

  export const DeleteClassificationRuleEndpoint = "/grpc/search_settings.ClassificationRules/DeleteClassificationRule";
  /** Delete a classification rule by ID */
  export function DeleteClassificationRule(sender: (req: DeleteClassificationRuleRequest, endpoint: string) => Promise<DeleteClassificationRuleResponse>, req: DeleteClassificationRuleRequest): { promise: () => Promise<DeleteClassificationRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteClassificationRuleEndpoint),
      endpoint: DeleteClassificationRuleEndpoint
    };
  }

  export const GetClassificationRuleEndpoint = "/grpc/search_settings.ClassificationRules/GetClassificationRule";
  /** Get a classification rule by ID */
  export function GetClassificationRule(sender: (req: GetClassificationRuleRequest, endpoint: string) => Promise<GetClassificationRuleResponse>, req: GetClassificationRuleRequest): { promise: () => Promise<GetClassificationRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetClassificationRuleEndpoint),
      endpoint: GetClassificationRuleEndpoint
    };
  }

  export const GetAllClassificationRulesEndpoint = "/grpc/search_settings.ClassificationRules/GetAllClassificationRules";
  /** List all classification rules */
  export function GetAllClassificationRules(sender: (req: GetAllClassificationRuleRequest, endpoint: string) => Promise<GetAllClassificationRuleResponse>, req: GetAllClassificationRuleRequest): { promise: () => Promise<GetAllClassificationRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllClassificationRulesEndpoint),
      endpoint: GetAllClassificationRulesEndpoint
    };
  }
}

export namespace ClassificationRulesPublic {

  export const SetClassificationRuleEndpoint = "/grpc/search_settings.ClassificationRulesPublic/SetClassificationRule";
  /** Create/update existing classification rule */
  export function SetClassificationRule(sender: (req: SetClassificationRuleRequest, endpoint: string) => Promise<SetClassificationRuleResponse>, req: SetClassificationRuleRequest): { promise: () => Promise<SetClassificationRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetClassificationRuleEndpoint),
      endpoint: SetClassificationRuleEndpoint
    };
  }

  export const DeleteClassificationRuleEndpoint = "/grpc/search_settings.ClassificationRulesPublic/DeleteClassificationRule";
  /** Delete a classification rule by ID */
  export function DeleteClassificationRule(sender: (req: DeleteClassificationRuleRequest, endpoint: string) => Promise<DeleteClassificationRuleResponse>, req: DeleteClassificationRuleRequest): { promise: () => Promise<DeleteClassificationRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteClassificationRuleEndpoint),
      endpoint: DeleteClassificationRuleEndpoint
    };
  }

  export const GetClassificationRuleEndpoint = "/grpc/search_settings.ClassificationRulesPublic/GetClassificationRule";
  /** Get a classification rule by ID */
  export function GetClassificationRule(sender: (req: GetClassificationRuleRequest, endpoint: string) => Promise<GetClassificationRuleResponse>, req: GetClassificationRuleRequest): { promise: () => Promise<GetClassificationRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetClassificationRuleEndpoint),
      endpoint: GetClassificationRuleEndpoint
    };
  }

  export const GetAllClassificationRulesEndpoint = "/grpc/search_settings.ClassificationRulesPublic/GetAllClassificationRules";
  /** List all classification rules */
  export function GetAllClassificationRules(sender: (req: GetAllClassificationRuleRequest, endpoint: string) => Promise<GetAllClassificationRuleResponse>, req: GetAllClassificationRuleRequest): { promise: () => Promise<GetAllClassificationRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllClassificationRulesEndpoint),
      endpoint: GetAllClassificationRulesEndpoint
    };
  }
}

export interface SetClassificationRuleRequest {
  orgId: string;
  classificationRule: ClassificationRule | null;
}

export interface SetClassificationRuleResponse {
  classificationRuleRecord: ClassificationRuleRecord | null;
}

export interface DeleteClassificationRuleRequest {
  orgId: string;
  classificationRuleId: string;
}

export interface DeleteClassificationRuleResponse {
  classificationRuleId: string;
}

export interface GetClassificationRuleRequest {
  orgId: string;
  classificationRuleId: string;
}

export interface GetClassificationRuleResponse {
  classificationRuleRecord: ClassificationRuleRecord | null;
}

export interface GetAllClassificationRuleRequest {
  orgId: string;
}

export interface GetAllClassificationRuleResponse {
  classificationRuleRecords: ClassificationRuleRecord[];
}

export interface ClassificationRuleRecord {
  classificationRule: ClassificationRule | null;
  metadata: protoauditstore.AuditMetadata | null;
}

export interface ClassificationRule {
  id: string;
  /** object Id can be named element id, event id, etc. */
  objectId?: string;
  /** The type of the object this rule applies to (i.e. element) */
  classificationObjectType: ClassificationObjectType;
  /** The classification type to be applied to the element (i.e. PII, Financial, etc) */
  classification: Classification;
}

export namespace ClassificationRule {
  export enum data_object {
    /** object Id can be named element id, event id, etc. */
    objectId = 2
  }

  export function data_object_oneof(m: ClassificationRule): { opt: data_object.objectId, val: string } | null {
    if (m.objectId != null) { return { opt: data_object.objectId, val: m.objectId } }
    return null;
  }
}

export enum Classification {
  CLASSIFICATION_UNSPECIFIED = 0,
  CLASSIFICATION_PII = 1,
  CLASSIFICATION_FINANCIAL = 2,
  CLASSIFICATION_RESTRICTED = 3,
  /** Intentionally unrestricted an element */
  CLASSIFICATION_UNRESTRICTED = 4
}

/** The set of object types that can be classified. */
export enum ClassificationObjectType {
  CLASSIFICATION_OBJECT_TYPE_UNSPECIFIED = 0,
  CLASSIFICATION_OBJECT_TYPE_ELEMENT = 1
}
